module.exports = __webpack_public_path__ + "static/CrimsonText-Bold-060a8117c94ab988ca9b31d046165325.ttf";